const restricted = {
  restricted_access: 'Restricted access',
  you_don_t_have_access_to_this_activity_it_could_be_because:
    'You don’t have access to this activity. It could be because:',
  you_are_not_an_instructor_in_the_acadly_course_that_has_this_activity:
    'You are not an instructor in the Acadly course that has this activity',
  you_are_not_an_in_charge_of_the_lecture_that_has_this_activity:
    'You are not an in-charge of the lecture that has this activity',
  this_activity_has_been_removed: 'This activity has been removed',
  to_replace_this_activity_please_add_a_new_slide_and_remove_this_slide:
    'To replace this activity, please add a new slide and remove this slide',
} as const;

export default restricted;
